import type { DriverInactivityAlert } from "./driverActivity";
import { formatMinutes } from "./towerFormat";

// Cómo se abre el detalle de un chofer: con qué filtro y, si se llega desde
// una alerta, con el aviso de qué la disparó arriba de todo.
export type DriverFocus = { tone: "critical" | "warning" | "muted" | "previous"; title: string; detail: string };
export type DriverOpenOptions = {
  // Filtro de la lista por estado, o "all".
  status?: string;
  // Recorte del contador que se tocó: zona y tipo de envío.
  zone?: string;
  universe?: "FLEX" | "NON_FLEX";
  mapStatus?: "inTransit" | "notDelivered" | "all";
  focus?: DriverFocus;
};

// Texto corto de la alerta de "sin entregas": tuvo movimiento hoy y no entregó, o hoy
// no registró ningún movimiento (lo que tiene viene de días anteriores).
export function noDeliveriesLabel(movedToday: boolean) {
  return movedToday ? "Sin entregas aún" : "Sin movimiento hoy";
}

export function noDeliveriesHelp(movedToday: boolean) {
  return movedToday
    ? "Tiene Flex en camino y movimiento hoy, pero todavía no registró ninguna entrega."
    : "Tiene Flex en camino de días anteriores y hoy no registró ningún movimiento.";
}

// Detalle del chofer abierto desde una alerta de inactividad.
export function inactivityOpenOptions(
  alert: NonNullable<DriverInactivityAlert>,
  flexInTransit: number,
  lastDelivery: string | null,
): DriverOpenOptions {
  const flex = `${flexInTransit} Flex en camino`;
  if (alert.level === "noDeliveries")
    return {
      // Todo lo que tiene en camino; los de días anteriores van marcados en la lista.
      status: "inTransit",
      mapStatus: "inTransit",
      focus: {
        tone: alert.movedToday ? "muted" : "previous",
        title: noDeliveriesLabel(alert.movedToday),
        detail: `${noDeliveriesHelp(alert.movedToday)} ${flex}.`,
      },
    };
  return {
    status: "inTransit",
    mapStatus: "inTransit",
    focus: {
      tone: alert.level,
      title: `${formatMinutes(alert.idleMinutes)} sin entregar`,
      detail: `Última entrega a las ${lastDelivery?.slice(11) || "—"} · ${flex}. Abajo, lo que tiene en camino.`,
    },
  };
}

// Columna "Seguimiento": una sola etiqueta. Si hay alerta de inactividad,
// manda la alerta (Crítico / Alerta / Sin entregas); si no, el estado.
export function followUpPill(alert: DriverInactivityAlert, state: { label: string; tone: string }) {
  if (alert?.level === "critical") return { label: "Crítico", tone: "incident" };
  if (alert?.level === "warning") return { label: "Alerta", tone: "delayed" };
  if (alert?.level === "noDeliveries")
    return { label: alert.movedToday ? "Sin entregas" : "Sin movimiento", tone: "noDeliveries" };
  return state;
}
